import React from "react";
import "./screenCard.scss";

interface ScreenCardProps {
    id: string;
    img?: string;
    onClick?: () => void;
    onSelect?: () => void;
    isSelected?: boolean;
}

const ScreenCard: React.FC<ScreenCardProps> = ({ id, img, onClick, onSelect, isSelected }) => {

    console.log('isSlelected', isSelected)
    return (
        <div className={`screen-card ${isSelected ? "selected" : ""}`} key={id}>
            <div className="radio-btn">
                <label htmlFor="checkbox"></label>
                <input type="checkbox" checked={isSelected} onChange={onSelect} id="checkbox" />
            </div>
            <img src={img} alt="img" className="screen-img" onClick={onClick} />
        </div>
    );
};

export default ScreenCard;
